import Vue from 'vue'
import Loader from '../partials/Loader.vue'

const LoaderConstructor = Vue.extend(Loader)

export default {
  install (Vue) {
    const loaderInstance = new LoaderConstructor()
    loaderInstance.$mount(document.createElement('div'))
    document.body.appendChild(loaderInstance.$el)

    Vue.prototype.$loader = {
      show () {
        loaderInstance.show()
      },
      hide () {
        loaderInstance.hide()
      }
    }
  }
}